import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Small modal asking the user for a name before saving the current PICOST
 * generation to the grade_revisions table. Returns the trimmed name via
 * dialogRef.close(name), or undefined if cancelled.
 */
@Component({
  selector: 'app-picost-name-dialog',
  standalone: true,
  imports: [
    MatDialogModule, MatButtonModule, MatIconModule,
    MatFormFieldModule, MatInputModule, FormsModule, TranslateModule
  ],
  template: `
    <h2 mat-dialog-title>Salva PICOST</h2>
    <mat-dialog-content>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nome del PICOST</mat-label>
        <input matInput [(ngModel)]="name" name="name"
          (keydown.enter)="confirm()" cdkFocusInitial autocomplete="off">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="cancel()">
        {{ 'generic.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="!name.trim()" (click)="confirm()">
        <mat-icon class="mr-1">save</mat-icon>
        {{ 'generic.buttons.save' | translate }}
      </button>
    </mat-dialog-actions>
  `
})
export class PicostNameDialogComponent {
  name: string;

  constructor(
    public dialogRef: MatDialogRef<PicostNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { suggestedName?: string }
  ) {
    this.name = data?.suggestedName || '';
  }

  confirm(): void {
    const trimmed = (this.name || '').trim();
    if (trimmed) {
      this.dialogRef.close(trimmed);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
